import React, { useEffect, useState } from 'react'
import { Form, Input, Radio, Button, Cascader, message } from 'antd'
// @ts-ignore
import provinceList from '@sisyphe/province-city-data'
import { useRequest } from '@sisyphe/hooks'
import * as api from 'services/user'
import './index.less'
import { DefaultOptionType } from 'antd/es/cascader'

const layout = {
  labelCol: { span: 7 },
  wrapperCol: { span: 16 },
}

interface AddEditProps {
  onCancel?: Function
  onOk?: Function
  data?: SwaggerDTO.地址信息
}

export default function AddEdit({ data, onCancel, onOk }: AddEditProps) {
  const [area, setArea] = useState<DefaultOptionType[]>()
  const [form] = Form.useForm()
  /**用户地址新增 */
  const { run: addressAddUsingPOST, loading } = useRequest(
    async params => {
      const serveApi = data ? api.addressEditUsingPOST : api.addressAddUsingPOST
      await serveApi({
        ...data,
        ...params,
      })
      message.success('操作成功')
      onCancel?.()
      onOk?.()
    },
    { manual: true }
  )

  const onFinish = values => {
    let params = {
      ...values,
      provinceId: area?.[0]?.value,
      provinceName: area?.[0]?.label,
      cityId: area?.[1]?.value,
      cityName: area?.[1]?.label,
      areaId: area?.[2]?.value,
      areaName: area?.[2]?.label,
    }
    addressAddUsingPOST(params)
  }

  useEffect(() => {
    if (!data) return
    form.setFieldsValue({
      ...data,
      area: [
        data?.provinceId?.toString(),
        data?.cityId?.toString(),
        data?.areaId?.toString(),
      ],
    })
    setArea([
      { value: data?.provinceId, label: data?.provinceName },
      { value: data?.cityId, label: data?.cityName },
      { value: data?.areaId, label: data?.areaName },
    ])
  }, [form, data])

  return (
    <div className="address-add-edit">
      <Form {...layout} onFinish={onFinish} form={form}>
        <Form.Item label="收货人" name="addressee" rules={[{ required: true }]}>
          <Input placeholder="请输入收货人" maxLength={50} />
        </Form.Item>
        <Form.Item
          label="联系电话"
          name="linkMobile"
          rules={[
            {
              required: true,
              validator(rule, value, callback) {
                if (!value) callback('请输入联系电话')

                if (!/^1[3-9]\d{9}$/.test(value)) {
                  callback('联系电话格式错误')
                }
                callback()
              },
            },
          ]}
        >
          <Input placeholder="请输入联系电话" maxLength={11} />
        </Form.Item>
        <Form.Item
          label="所在地区"
          name="area"
          rules={[{ required: true, message: '请选择所在地区' }]}
        >
          <Cascader
            options={provinceList}
            placeholder="请选择所在地区"
            onChange={(keys, rows) => setArea(rows)}
          />
        </Form.Item>
        <Form.Item label="详细地址" name="address" rules={[{ required: true }]}>
          <Input.TextArea
            rows={5}
            placeholder="请输入详细地址"
            maxLength={200}
          />
        </Form.Item>
        <Form.Item
          label="设为默认收货地址"
          name="defaultAddressTag"
          rules={[{ required: true, message: '请设置默认收货地址' }]}
        >
          <Radio.Group>
            <Radio value={1}>是</Radio>
            <Radio value={0}>否</Radio>
          </Radio.Group>
        </Form.Item>
        <div className="address-add-edit-btn">
          <Button type="primary" htmlType="submit" loading={loading}>
            保存收货地址
          </Button>
        </div>
      </Form>
    </div>
  )
}
